import { render } from "./template.vue?vue&type=template&id=0076af2e&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=0076af2e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0076af2e"]])

export default __exports__